import React from "react";
import "./FullScreenTnc.css";
import { LeftOutlined, CloseOutlined } from "@ant-design/icons";

const FullScreenTnc = ({ onClose }) => {
  return (
    <div className="tncContainer">
      <div className="tncHeader">
        <LeftOutlined className="tncHeaderIcon" onClick={onClose} />
        <div className="tncHeaderTitle">Food on Bus - T&C</div>
        <CloseOutlined className="tncHeaderIcon" onClick={onClose} />
      </div>

      <div className="tncContent">
        <h3>Cancellation:</h3>
        <li>
          <li>Food orders can be cancelled without cancelling the booking.</li>
          <li>
            Cancellation Window: Food orders can be cancelled up to 6 hours
            before the trip.
          </li>
          <li>
            Food orders can not be cancelled less than 6 hours before the trip.
          </li>

          <li>
            <b>Partial food item cancellation is not applicable.</b>.
          </li>

          <li>
            <b>Rescheduling Trips:</b>
            <ul>
              <li>
                {" "}
                If a trip is rescheduled by zingbus, the existing food order
                will be automatically cancelled.
              </li>
              <li>
                If the rescheduling occurs more than 6 hours before the trip, a
                refund will be issued.
              </li>
              <li>
                If the rescheduling occurs within 6 hours of departure, no
                refund will be provided.
              </li>
            </ul>
          </li>

          <li>
            <b> Cross-Asset Transfers: </b> Food orders cannot be transferred to
            a different bus.
          </li>

          <li>
            The customer will not be able to change the boarding city if the
            user has booked food.
          </li>
        </li>

        <li>
          <b> Refund Slabs:</b>
          <ul>
            <li>Last 6 Hours, no refund will be initiated</li>
            <li>Before 6 Hours 50% refund will be issued</li>
            <li>Before 12 Hours 100% refund will be issued</li>
          </ul>
        </li>

        <li>
          <b>Refund Processing:</b> Refunds (where applicable) will be processed
          by the Customer Support team after verifying the item-level amount
          paid by the customer.
        </li>

        <h3>Refund will be provided in the cases of</h3>
        <ul>
          <li>Packaging-related corners/spillage</li>
          <li>Rotten foods or bad quality</li>
          <li>Soggy or cold food items, which are not edible</li>
          <li>Missing items from the restaurant side</li>
          <li>In case of bus delays</li>
          <li>In the case of food handover delays</li>
          <li>If the wrong food is served to the customer</li>
        </ul>
      </div>
    </div>
  );
};

export default FullScreenTnc;
